// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"592":"953d452d8759b189","888":"8ee485013d42af8d"}[chunkId] + ".css";
};